// frontend/src/components/content/PostForm.js (فایل جدید)

import React, { useState } from 'react';
import { FaPaperPlane, FaSpinner } from 'react-icons/fa';
import axiosInstance from '../../modules/api';

const PostForm = ({ lessonId, parentId = null, buttonText = "ارسال", onSuccess }) => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) return;

        setLoading(true);
        setError(null);

        let url = '';
        const payload = { content };

        if (parentId) {
            // این یک "پاسخ" است
            url = `/core/posts/${parentId}/reply/`;
        } else {
            // این یک "سوال جدید" برای درس است
            url = `/core/lessons/${lessonId}/posts/`;
        }

        try {
            await axiosInstance.post(url, payload);
            setContent(""); // فرم را پاک کن
            onSuccess(); // به کامپوننت والد بگو که رفرش کند
        } catch (err) {
            console.error("Error posting message:", err);
            setError("خطا در ارسال پیام.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="discussion-form">
            {error && <div className="alert alert-danger" style={{fontSize: '0.9rem', padding: '8px'}}>{error}</div>}
            <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder={parentId ? "پاسخ خود را بنویسید..." : "سوال جدید خود را در مورد این درس بپرسید..."}
                rows={3}
                required
                disabled={loading}
            />
            <button type="submit" className="button button-primary" disabled={loading}>
                {loading ? <FaSpinner className="spinner" /> : <FaPaperPlane />}
                {buttonText}
            </button>
        </form>
    );
};

export default PostForm;